import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Highlights from './components/Highlights';
import LessonsLearned from './components/LessonsLearned';
import Recommendations from './components/Recommendations';
import Timeline from './components/Timeline';
import MeetingNotes from './components/MeetingNotes';
import Contact from './components/Contact';
import Footer from './components/Footer';

const AppContainer = styled.div`
  font-family: 'Inter', sans-serif;
  line-height: 1.6;
  color: #333;
  background-color: #fff;
`;

function App() {
  return (
    <AppContainer>
      <Navigation />
      <Hero />
      <Highlights />
      <LessonsLearned />
      <Recommendations />
      <MeetingNotes />
      <Timeline />
      <Contact />
      <Footer />
    </AppContainer>
  );
}

export default App;
